import { useMemo } from 'react';
import { useSpaceData } from './use-space-data';
const EMPTY_CHANNELS = [];
export function useChannels() {
    const data = useSpaceData();
    // flatmap channels
    return useMemo(() => {
        return data?.channelGroups ? getChannelsFromSpaceData(data.channelGroups) : EMPTY_CHANNELS;
    }, [data?.channelGroups]);
}
export function getChannelsFromSpaceData(channelGroups) {
    return channelGroups.reduce((channels, group) => {
        return [...channels, ...group.channels];
    }, []);
}
//# sourceMappingURL=use-channels.js.map